import { render } from "./NewsPageSide.vue?vue&type=template&id=70d66ad2"
import script from "./NewsPageSide.vue?vue&type=script&lang=js"
export * from "./NewsPageSide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__